import React from "react";
import Chart from "react-google-charts";
import NoDataFound from "../Masters/NoDataFound";
import { Box } from "@mui/material";

const GlobalChart = ({ height, tableData }) => {
  let data = [["Country", "Emission Percentage"]];
  // const convertData = (data) => [
  //   ["Country", "Emission Percentage"],
  //   ...data.map(({ country, percentage }) => [country, Math.round(percentage)]),
  // ];

  const convertData = (data) => [
    ["Country", "Emission Percentage"],
    ...data.map(({ country, percentage }) => [
      country,
      percentage
        ? percentage.toString().includes(".")
          ? percentage.toString().split(".")[0] +
            "." +
            percentage.toString().split(".")[1].slice(0, 2)
          : percentage
        : 0,
    ]),
  ];

  let finalData = tableData?.length > 0 ? convertData(tableData) : data;

  const options = {
    backgroundColor: 'transparent',
    datalessRegionColor: '#f8f9fa',
    colorAxis: {
      colors: ['#e6f3e6', '#4CAF50'], // Light green to darker green
      minValue: 0,
      maxValue: 100
    },
    legend: {
      textStyle: {
        color: '#666'
      }
    },
    defaultColor: '#4CAF50'
  };

  return (
    <>
      {tableData?.length > 0 ? (
        <Chart
          chartEvents={[
            {
              eventName: "select",
              callback: ({ chartWrapper }) => {
                const chart = chartWrapper.getChart();
                const selection = chart.getSelection();
                if (selection.length === 0) return;
                const region = data[selection[0].row + 1];
              },
            },
          ]}
          chartType="GeoChart"
          width="95%"
          height={height ? height : "300px"}
          data={finalData}
          options={options}
        />
      ) : (
        <Box sx={{ height: "25rem" }}>
          <NoDataFound mt={"25%"} />
        </Box>
      )}
    </>
  );
};

export default GlobalChart;
